var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errorText
    ? _c("div", {
        staticClass: "order-error",
        domProps: { innerHTML: _vm._s(_vm.errorText) }
      })
    : _c(
        "div",
        { staticClass: "order-card-wrap" },
        [
          _c(
            "div",
            {
              class: [
                "order-card",
                {
                  "order-card-collapsed": !_vm.isExpanded,
                  "order-card-last": _vm.isLast,
                  "order-card-expanded-last": _vm.isExpanded && _vm.isLast
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass: "order-card-head",
                  on: { click: _vm.handleToggle }
                },
                [
                  _c("div", { staticClass: "number" }, [
                    _vm._v(
                      "\n        Заказ № " +
                        _vm._s(_vm.order.orderNumber) +
                        "\n        "
                    ),
                    _c(
                      "span",
                      {
                        class: [
                          "order-card__status",
                          { "order-card__status_warning": _vm.warnStatus }
                        ]
                      },
                      [_vm._v(_vm._s(_vm.status))]
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "order-card-head-buttons" },
                    [
                      _vm.prepayOpportunity && _vm.order.subtotal
                        ? _c("ui-button", {
                            staticClass: "button",
                            attrs: {
                              text:
                                "Оплатить " +
                                _vm.$options.filters.price(_vm.order.subtotal) +
                                " ₽"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.pay($event)
                              }
                            }
                          })
                        : _vm._e(),
                      _c("vue-client-only", [
                        _vm.adaptive.isDesktop
                          ? _c(
                              "div",
                              {
                                staticClass: "print-button",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.print($event)
                                  }
                                }
                              },
                              [
                                _c("f-sprite-icon", {
                                  attrs: {
                                    "icon-link": _vm.$options.icons.IconPrint.id
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _c(
                        "div",
                        { staticClass: "order-card-toggle-arrow" },
                        [
                          _c("chevron-animated", {
                            attrs: { reverse: _vm.isExpanded }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm.isExpanded
                ? [
                    _c("div", { staticClass: "order-card-info" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v("\n          Получатель\n          "),
                        _c("span", [_vm._v(_vm._s(_vm.fullName))])
                      ]),
                      _c("div", { staticClass: "phone" }, [
                        _vm._v("\n          Телефон\n          "),
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("prettyPhone")(_vm.phone)))
                        ])
                      ]),
                      _c("div", { staticClass: "delivery" }, [
                        _vm._v("\n          Способ доставки\n          "),
                        _c("span", [_vm._v(_vm._s(_vm.delivery))])
                      ]),
                      _c("div", { staticClass: "payment" }, [
                        _vm._v("\n          Способ оплаты\n          "),
                        _c("span", [_vm._v(_vm._s(_vm.payment))])
                      ]),
                      _c(
                        "div",
                        {
                          class: ["payment-status", { paid: _vm.isOrderPaid }]
                        },
                        [
                          _vm._v("\n          Статус оплаты\n          "),
                          _c("div", [
                            _vm.isOrderPaid
                              ? _c(
                                  "div",
                                  { staticClass: "payment-status__icon" },
                                  [
                                    _c("f-sprite-icon", {
                                      attrs: {
                                        "icon-link":
                                          _vm.$options.icons.IconSuccess.id
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("span", [_vm._v(_vm._s(_vm.paymentStatus))])
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "date" },
                        [
                          _vm.order.shippingGroupType === "delivery"
                            ? [
                                _vm._v(
                                  "\n            Дата доставки\n            "
                                ),
                                _c(
                                  "span",
                                  [
                                    _vm.order.receivingDateFrom &&
                                    _vm.order.receivingDateTo
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getIntervalDates(
                                                  _vm.order.receivingDateFrom,
                                                  _vm.order.receivingDateTo
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.deliveryTime
                                                  ? "c " +
                                                      _vm.order.deliveryTime
                                                  : ""
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._f("fullDate")(
                                                  _vm.order.receivingDateFrom
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.deliveryTime
                                                  ? "c " +
                                                      _vm.order.deliveryTime
                                                  : ""
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n            Можно забрать\n            "
                                ),
                                _c(
                                  "span",
                                  [
                                    _vm.order.receivingDateTo &&
                                    _vm.order.shippingGroupType === "thirdparty"
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getIntervalDates(
                                                  _vm.order.receivingDateFrom,
                                                  _vm.order.receivingDateTo
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._f("fullDate")(
                                                  _vm.order.receivingDateFrom
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "address" },
                        [
                          _vm.order.shippingGroupType === "delivery"
                            ? [
                                _vm._v(
                                  "\n            Адрес доставки\n          "
                                )
                              ]
                            : [_vm._v("\n            Адрес\n          ")],
                          _c("span", [_vm._v(_vm._s(_vm.order.address))])
                        ],
                        2
                      ),
                      _vm.schedule
                        ? _c("div", { staticClass: "schedule" }, [
                            _vm._v("\n          Часы работы\n          "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.order.workSchedule[0].workTime))
                            ])
                          ])
                        : _vm._e(),
                      _vm.order.storagePeriod &&
                      _vm.order.shippingGroupType === "thirdparty"
                        ? _c("div", { staticClass: "storage" }, [
                            _vm._v("\n          Срок хранения:\n          "),
                            _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.order.storagePeriod) +
                                  " " +
                                  _vm._s(
                                    _vm._f("decl")(
                                      _vm.order.storagePeriod,
                                      "д",
                                      ["ень", "ня", "ней"]
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm.order.drivingDirections
                        ? _c("div", { staticClass: "hint" }, [
                            _vm._v("\n          Как добраться\n          "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.order.drivingDirections))
                            ])
                          ])
                        : _vm._e(),
                      _vm.order.insideLocation
                        ? _c("div", { staticClass: "hint" }, [
                            _vm._v("\n          Расположение\n          "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.order.insideLocation))
                            ])
                          ])
                        : _vm._e(),
                      _vm.order.comment
                        ? _c("div", { staticClass: "comment" }, [
                            _vm._v("\n          Комментарий\n          "),
                            _c("span", [_vm._v(_vm._s(_vm.order.comment))])
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "order-card-products" },
                      _vm._l(_vm.order.products, function(product, i) {
                        return _c("checkout-product", {
                          key: i,
                          attrs: { product: product }
                        })
                      }),
                      1
                    ),
                    _c("div", { staticClass: "dashed-table prices" }, [
                      _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.order.quantity) +
                              " " +
                              _vm._s(
                                _vm._f("decl")(_vm.order.quantity, "товар", [
                                  "",
                                  "а",
                                  "ов"
                                ])
                              ) +
                              " на сумму"
                          )
                        ]),
                        _c("span", { staticClass: "price-rub" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("price")(_vm.order.catalogAmount || 0)
                            )
                          )
                        ])
                      ]),
                      _c("div", [
                        _c("span", [_vm._v("Стоимость доставки")]),
                        _vm.order.deliveryAmount
                          ? _c("span", { staticClass: "price-rub" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("price")(_vm.order.deliveryAmount)
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]),
                      Number(_vm.order.discountsAmount)
                        ? _c("div", { staticClass: "discount accent" }, [
                            _c("span", [_vm._v("Скидка")]),
                            _c("span", { staticClass: "price-rub" }, [
                              _vm._v(
                                "\n            - " +
                                  _vm._s(
                                    _vm._f("price")(_vm.order.discountsAmount)
                                  ) +
                                  "\n          "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "large" }, [
                        _c("span", [_vm._v("Всего к оплате")]),
                        _c("span", { staticClass: "price-rub" }, [
                          _vm._v(
                            _vm._s(_vm._f("price")(_vm.order.subtotal || 0))
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "order-buttons" }, [
                      _c(
                        "span",
                        {
                          staticClass: "link-blue",
                          on: {
                            click: function($event) {
                              return _vm.$emit("on-close")
                            }
                          }
                        },
                        [_vm._v("\n          К списку заказов\n        ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _vm.prepayOpportunity && _vm.order.subtotal
                            ? _c("ui-button", {
                                attrs: {
                                  wide: "",
                                  text:
                                    "Оплатить " +
                                    _vm.$options.filters.price(
                                      _vm.order.subtotal
                                    ) +
                                    " ₽"
                                },
                                on: { click: _vm.pay }
                              })
                            : _vm._e(),
                          _vm.order.cancellation === "available"
                            ? _c("ui-button", {
                                attrs: {
                                  wide: "",
                                  secondary: "",
                                  text: "Отменить заказ"
                                },
                                on: { click: _vm.loadCancelReasons }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                : _vm._e(),
              !_vm.isLoaded
                ? _c(
                    "div",
                    { staticClass: "loader" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade" } },
                        [
                          !_vm.isLoaded
                            ? _c("ui-loader", { attrs: { size: "60" } })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm.showSupportInfo
            ? _c("order-support", { staticClass: "hint order-card-support" }, [
                _vm._v(
                  "\n    С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте  "
                ),
                _c("a", { attrs: { href: "mailto:helpme@fundayshop.com" } }, [
                  _vm._v("helpme@fundayshop.com")
                ]),
                _vm._v(" или по телефону "),
                _c("a", { attrs: { href: "tel:+78007700101" } }, [
                  _vm._v("8 800 770-01-01")
                ]),
                _vm._v(" (по России бесплатно), с 7:00 до 22:00 (мск)\n  ")
              ])
            : _vm._e(),
          _c(
            "modal",
            {
              attrs: { visible: _vm.cancelCard },
              on: {
                "on-close": function($event) {
                  _vm.cancelCard = false
                }
              }
            },
            [
              _c("cancel-card", {
                attrs: {
                  "order-number": _vm.orderNumber,
                  reasons: _vm.reasons
                },
                on: {
                  "on-close": function($event) {
                    _vm.cancelCard = false
                  },
                  "on-order-update": _vm.updateOrder
                }
              })
            ],
            1
          ),
          _c("fast-payment-system-modal", {
            attrs: { data: _vm.fpsPaymentData },
            model: {
              value: _vm.isFpsPaymentVisible,
              callback: function($$v) {
                _vm.isFpsPaymentVisible = $$v
              },
              expression: "isFpsPaymentVisible"
            }
          }),
          _c("payment-methods-modal", {
            attrs: {
              "payment-methods": _vm.paymentMethods,
              loading: _vm.isLoadingPayment
            },
            on: { select: _vm.onSelectPaymentMethod },
            model: {
              value: _vm.isPaymentMethodsVisible,
              callback: function($$v) {
                _vm.isPaymentMethodsVisible = $$v
              },
              expression: "isPaymentMethodsVisible"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }